import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canSeeIntegrations } from "utils/roles";

type AdminRouteProps = {
  children: ReactNode;
};

const AdminRoute = ({ children }: AdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user && !user.is_pass_reset) {
    return <Navigate to="/reset-password" replace />;
  }

  if (!user || !canSeeIntegrations(user.platform_profile)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
